import * as React from "react";
import type { SVGProps } from "react";
const SvgRectangleLined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={12}
    height={12}
    fill="none"
    viewBox="0 0 12 12" {...props}
  >
    <rect
      width={11}
      height={11}
      x={0.5}
      y={0.5}
      fill="url(#Rectangle-Lined_svg__a)"
      stroke="#000"
      rx={1.5}
    />
    <defs>
      <pattern
        id="Rectangle-Lined_svg__a"
        width="45.833%"
        height="43.75%"
        x={-0.345}
        y={-0.361}
        patternContentUnits="objectBoundingBox"
        patternUnits="userSpaceOnUse"
        viewBox="1448.5 635.25 5.5 5.25"
      >
        <path
          id="Rectangle-Lined_svg__b"
          stroke="#020F20"
          d="m1454 630-11 10.5"
        />
        <use xlinkHref="#Rectangle-Lined_svg__b" transform="translate(5.5)" />
        <use
          xlinkHref="#Rectangle-Lined_svg__b"
          transform="translate(0 5.25)"
        />
        <use
          xlinkHref="#Rectangle-Lined_svg__b"
          transform="translate(5.5 5.25)"
        />
      </pattern>
    </defs>
  </svg>
);
export default SvgRectangleLined;
